"use client";

import React from "react";
import MobileNavigation from "./mobile-navigation";
import DesktopNavigation from "./desktop-navigation";
import { NavItem } from "@/lib/data";

export interface NavigationProps {
  links?: NavItem[];
}

export default function Navigation({ links = [] }: NavigationProps) {
  return (
    <>
      <MobileNavigation
        className="sticky z-60 lg:hidden"
        links={links}
      />
      <DesktopNavigation
        className="sticky top-0 z-60 hidden lg:block"
        links={links}
      />
    </>
  );
}
